import { BaseInput } from './NewInput'
import MaskInput from './MaskInput'

const IbanInput: React.FC<BaseInput> = ({ value, onChange }) => {
  return <MaskInput mask="DE99 9999 9999 9999 9999 99" value={value} onChange={onChange} type="text" />
}

export default IbanInput
